import { useRequest } from '~/repositories'

/** Fetches the full list of lotteries available in the platform from the v1 API. */
export const getLotteryList = () => {
	return useRequest('get', `/v1/lottery/list/`, {})
}

export default {
	getLotteryList,
}
